import { Component, Output, EventEmitter, Input } from '@angular/core';
import { AgentscriptService_updated } from 'src/app/services/agent-script-service/agent-script-service';
import { StandardUIService } from 'src/app/services/standardui-service/standardui-service';
import Swal from 'sweetalert2/dist/sweetalert2.js';


@Component({
  selector: 'app-create-new-sr',
  templateUrl: './create-new-sr.component.html',
  styleUrls: ['./create-new-sr.component.scss']
})

export class CreateNewSRComponent {
  @Output() componentSelection = new EventEmitter<any>();
  @Input() componentData:any;
  @Output() dataInformation=new EventEmitter();

  currDiv: string = this.agentscriptservice.defaultview
  serviceTypeInfo: any = {};
  dataInfo: any = {};
  containerHeight: any;
  tcontainer = {};
  tab_title:any
  constructor(private agentscriptservice:AgentscriptService_updated,private standardservice:StandardUIService) {

  }

  loaddataInfo()
  {
    this.dataInfo={}
    console.log("in loadInfo")
    // console.log()

    // this.agentscriptservice.fetchData(this.tab_title,'dataInfo',e[0])

    var dataInformation=this.agentscriptservice.fetchData(this.tab_title,'casetypedata')
    console.log(dataInformation)
    if(dataInformation!=0)
    {
      console.log(dataInformation.serviceDetails)
      setTimeout(() => {
      this.dataInfo.casetypename= dataInformation?.serviceDetails?.content
      this.dataInfo.divisionname= dataInformation?.serviceDetails?.division.name
      this.dataInfo.departmentname= dataInformation?.serviceDetails?.department.name
      });
    }

    // console.log(this.dataInfo)
  }
  ngOnInit(){

    // this.dataInfo=false;

    this.tab_title=$(".custom-tabs li.active").find("a").attr('data-obj-title')

    console.log(this.agentscriptservice.fetchData(this.tab_title, 'scriptpayloaddata'))
    console.log(this.agentscriptservice.AlldataArray)

    let navbarH = $('.layout-navbar').height();
    let docH = $(window).height();
    this.containerHeight = (docH - navbarH - 115) + 'px';

    this.tcontainer = {
    'height': this.containerHeight,
    'overflow': 'hidden',
    'overflow-y':'auto'
    };


    if(this.componentData && this.componentData.viewname == "addressView"){
      console.log("hehe")
      console.log(this.componentData.serviceDetails)
      // this.dataInfo= this.componentData.serviceDetails;
      this.currDiv = this.componentData.viewname;
      console.log(this.componentData.serviceDetails)
      this.componentData["serviceDetails"] = this.componentData.serviceDetails;
    }
  }
  ShowDiv(divVal: string) {
    this.currDiv = divVal;
  }

  gotoMain(){
    this.currDiv = this.serviceTypeInfo.redirectTo?this.serviceTypeInfo.redirectTo:this.agentscriptservice.defaultview;
    }

  bredCrumbChanges(data: any) {
    this.dataInfo = data;
  }
  componentSelectionEmitter(data){
    console.log("activesrdatavalue",data);
    this.componentSelection.emit(data);

  }


  responseFromChild(e: any) {

    // this.loaddataInfo();
    console.log(this.agentscriptservice.AlldataArray)
    this.serviceTypeInfo = e;
    console.log(e);

    // var componentData=this.agentscriptservice.fetchData(this.tab_title,'casetypedata')


    // this.loaddataInfo([
    //   {
    //     "casetypename":componentData.serviceDetails.content,
    //     "divisionname":componentData.serviceDetails.division.name,
    //     "departmentname":componentData.serviceDetails.department.name
    //   }
    // ])

    // this.agentscriptservice.updateOrInsertArray(this.tab_title,'casetypedata',e)

    console.log(this.agentscriptservice.fetchData(this.tab_title, 'scriptpayloaddata'))
    console.log(this.agentscriptservice.AlldataArray)

    this.dataInfo = 'hi'
    this.currDiv = e.viewname;
    if(e.viewname=='addressView')
    {
      console.log(e)
      console.log(e.serviceDetails)
      // this.agentscriptservice.updateOrInsertArray(this.tab_title,'casetypedata',e)
      this.componentData = e;
      // this.currDiv = e.viewname;
    }
    // if (e.viewname == 'agentscriptView' && e.isSubmit) {
    //   const payload = {
    //     "entityName": "Incident",
    //     "payLoad": {
    //       "IncidentRefId":this.componentData.tabid,
    //       "casetype": e.serviceDetails.caseTypeData.casetypeid,
    //       "casesubtype": e.serviceDetails.caseTypeData.casesubtypeid ? e.serviceDetails.caseTypeData.casesubtypeid : '',
    //       "department": e.serviceDetails.caseTypeData.department?.id,
    //       "division": e.serviceDetails.caseTypeData.division?.id,
    //       "incidentqueue": e.serviceDetails.caseTypeData?.qid,
    //       ...e.serviceDetails.formScriptData,
    //       "contactidobject": {
    //         "emailalt1": e.serviceDetails.caseTypeData.contactDtls?.mailingadd,
    //         "lastname": e.serviceDetails.caseTypeData.contactDtls?.lastname,
    //         "alternateph": e.serviceDetails.caseTypeData.contactDtls?.phonenumber2,
    //         "firstname": e.serviceDetails.caseTypeData.contactDtls?.firstname,
    //         "phonenumber": e.serviceDetails.caseTypeData.contactDtls?.phonenumber1,
    //         "email": e.serviceDetails.caseTypeData.contactDtls?.emailaddress,
    //         "title": "1",
    //       },
    //       "addfields":{
    //         ...e.serviceDetails.addfields
    //       },
    //       "cart":{
    //         ...e.serviceDetails.cart
    //       },
    //       "tab":{
    //         "tab_id":$(".custom-tabs li.active").find("a").attr('data-obj-id')
    //       },

    //       "incidentstatus": 1,
    //       "servicerequestsource": 1356
    //     }
    //   }
    //   // console.log(payload);
    //   // console.log($(".custom-tabs li.active").find("a").attr('data-obj-id'))
    //   console.log(($(".custom-tabs li.active").find("a").attr('data-obj-title')))
    //   // this.componentSelection.emit({ id: "incident-new"+$(".custom-tabs li.active").find("a").attr('data-obj-id'), name: $(".custom-tabs li.active").find("a").attr('data-obj-title'), type: 'object', entityName: 'Incident', newSr: payload, department: e.serviceDetails.caseTypeData.department.name })
    //   this.componentSelection.emit({src: '../../assets/images/NewSRactive.svg', id: "incident-new"+$(".custom-tabs li.active").find("a").attr('data-obj-id'), name:e.serviceDetails.tabname, type: 'object', entityName: 'Incident', newSr: payload, department: e.serviceDetails.caseTypeData.department.name })

    // }


    // console.log(scriptpayloaddata?.serviceDetails?.formScriptData)
    if (e.viewname == 'agentscriptView' && e.isSubmit) {
      console.log(this.agentscriptservice.fetchData(this.tab_title,'casetypedata'))
      console.log(this.agentscriptservice.fetchData(this.tab_title,'scriptpayloaddata'))
      // var casetypedata=this.agentscriptservice.fetchData(this.tab_title,'casetypedata')
      // +" "+ scriptpayloaddata.serviceDetails.caseTypeData.casesubtypename ? scriptpayloaddata.serviceDetails.caseTypeData.casesubtypename : ''
    var scriptpayloaddata=this.agentscriptservice.fetchData(this.tab_title,'scriptpayloaddata')
    // var subject=scriptpayloaddata.serviceDetails.caseTypeData.division?.name +"-"+ scriptpayloaddata.serviceDetails.caseTypeData.department?.name+()+"-"+ scriptpayloaddata.serviceDetails.caseTypeData.content+" "+
    //  (scriptpayloaddata.serviceDetails.caseTypeData.casesubtypename ? +"-"+scriptpayloaddata.serviceDetails.caseTypeData.casesubtypename : '' )

    var subject=scriptpayloaddata.serviceDetails.caseTypeData.division?.name +"-"+ scriptpayloaddata.serviceDetails.caseTypeData.department?.name+(scriptpayloaddata.serviceDetails.caseTypeData.casesubtypename ?"-"+ scriptpayloaddata.serviceDetails.caseTypeData.casetypename+"-"+scriptpayloaddata.serviceDetails.caseTypeData.casesubtypename : "-"+ scriptpayloaddata.serviceDetails.caseTypeData.content)
    console.log(subject)
    const payload = {
        "entityName": "Incident",
        "payLoad": {
          "IncidentRefId":this.tab_title,
          // "parentid":scriptpayloaddata.serviceDetails.formScriptData?.parentid,
          "contactid":+scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.contactid,
          "casetype": scriptpayloaddata.serviceDetails.caseTypeData.casetypeid,
          "casesubtype": scriptpayloaddata.serviceDetails.caseTypeData.casesubtypeid ? scriptpayloaddata.serviceDetails.caseTypeData.casesubtypeid : '',
          "department": scriptpayloaddata.serviceDetails.caseTypeData.department?.id,
          "division": scriptpayloaddata.serviceDetails.caseTypeData.division?.id,
          "incidentqueue": scriptpayloaddata.serviceDetails.caseTypeData?.qid,
          "subject": subject,
          "incidenttypeworkspace":196,
          ...scriptpayloaddata.serviceDetails.formScriptData,
          "contactidobject": {
            "id":+scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.contactid,
            "contacttextarea": scriptpayloaddata.serviceDetails.formScriptData?.contacttextarea,
            "addressid": scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.mailingadd!='null'?scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.mailingadd:'',
            "lastname": scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.lastname,
            "alternateph": scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.phonenumber2,
            "emailalt1": scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.emailalt1,
            "firstname": scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.firstname,
            "phonenumber": scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.phonenumber1,
            "email": scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.emailaddress,
            "title": "1",
            "street":scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.street,
            "city":scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.city,
            "postalcode":scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.postalcode,
            "countryid":1,
            "providenceid":19
          },
          "addfields":{
            ...scriptpayloaddata.serviceDetails.addfields
          },
          "cart":{
            ...scriptpayloaddata.serviceDetails.cart
          },
          "tab":{
            "tab_id":$(".custom-tabs li.active").find("a").attr('data-obj-id')
          },

          "incidentstatus": 1,
          "servicerequestsource": 1356
        }
      }
      console.log(payload);
      // console.log($(".custom-tabs li.active").find("a").attr('data-obj-id'))
      console.log(($(".custom-tabs li.active").find("a").attr('data-obj-title')))
      console.log(this.agentscriptservice.AlldataArray)
      // this.componentSelection.emit({ id: "incident-new"+$(".custom-tabs li.active").find("a").attr('data-obj-id'), name: $(".custom-tabs li.active").find("a").attr('data-obj-title'), type: 'object', entityName: 'Incident', newSr: payload, department: e.serviceDetails.caseTypeData.department.name })
      // this.agentscriptservice.updateOrInsertArray(this.tab_title,'dynamiccomponentdata',{src: '../../assets/images/NewSRactive.svg', id: "incident-new"+$(".custom-tabs li.active").find("a").attr('data-obj-id'), name:scriptpayloaddata.serviceDetails.tabname, type: 'object', entityName: 'Incident', newSr: payload, department: scriptpayloaddata.serviceDetails.caseTypeData.department.name })
      if(scriptpayloaddata.serviceDetails.caseTypeData.casetypeid=='296' || this.agentscriptservice.getIfAssociated(this.tab_title).includes(true))
      {
        
        this.agentscriptservice.generatecustomcreatePayload(this.tab_title).subscribe((data:any)=>
        {
          console.log(data)
          // console.log(data[0])

          if (data) {
            
            for (let i = 0; i < data.length; i++) {
                if (data[i].hasOwnProperty('error') && data[i].error!=null) {
                    Swal.fire({
                      title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/warning.svg" class="animated-check" >Something went wrong,Please try again. If problem persists please contact support.</div></div>',
                      html:data[i].error,
                      imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                      imageHeight: 45,
                      icon: 'error',
                      showCloseButton: true,
                      showCancelButton: false,
                      focusConfirm: false,
                      confirmButtonText: `OK`,
                      cancelButtonText: 'Cancel'
                    })
                } else {
                   
                        if (data[i].entityName == "Incident") {

                          $('li.active .tab-close').trigger('click')
                          $("[data-obj-id='" + 'home' + "']").parent().trigger('click')
                          
                          this.agentscriptservice.getuserallnotifications()
                          this.agentscriptservice.getusernotifications()

                          Swal.fire({
                            title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/verified.svg" class="animated-check" >A New Service Request is submitted<br> SR ID: <span style="color:#275a8a"><u>'+data[i].payLoad.refno+"</span></u>"+'</div></div>',
                            icon: 'success',
                            imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                            imageHeight: 45,
                            showCloseButton: true,
                            showCancelButton: false,
                            focusConfirm: false,
                            confirmButtonText: `OK`,
                        }).then((result) => {
                                console.log(result)
                                });
                      }
                }
            }

        } else {
            // Swal.fire('Oops...! <br>Something went wrong,Please try again. If problem persists please contact support.', data.error, 'error');
            Swal.fire({
                title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/wrong.svg" class="animated-check" >Something went wrong,Please try again. If problem persists please contact support.</div></div>',
                html:data.error,
                imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                imageHeight: 45,
                icon: 'error',
                showCloseButton: true,
                showCancelButton: false,
                focusConfirm: false,
                confirmButtonText: `OK`,
                cancelButtonText: 'Cancel'
              })
        }

          // if(data[0].hasOwnProperty('error') && data[0].error!=null)
          // {
          //   // Swal.fire('Oops...! <br>Something went wrong,Please try again. If problem persists please contact support.', data.error, 'error');
          //   Swal.fire({
          //     title: '<div class="popup-content"><img src="../../assets/images/fortwayne-logo-agent.svg"  alt="Selected Image" class="selected-image"><div class="popup-text"> <img src="../../assets/images/warning.svg" class="animated-check" >Something went wrong,Please try again. If problem persists please contact support.</div></div>',
          //     html:data[0].error,
          //     icon: 'error',
          //     showCloseButton: true,
          //     showCancelButton: false,
          //     focusConfirm: false,
          //     confirmButtonText: `OK`,
          //     cancelButtonText: 'Cancel'
          //   })
          // }
          // else{
          //   // Swal.fire('Success!', "Submitted Successfully", 'success');
          //   $('li.active .tab-close').trigger('click')
          //   $("[data-obj-id='" + 'home' + "']").parent().trigger('click')
            
          //   this.agentscriptservice.getuserallnotifications()
          //   this.agentscriptservice.getusernotifications()
        
          //   Swal.fire({
          //     title: '<div class="popup-content"><img src="../../assets/images/fortwayne-logo-agent.svg"  alt="Selected Image" class="selected-image"><div class="popup-text"> <img src="../../assets/images/verified.svg" class="animated-check" >A New Service Request is submitted<br> SR ID:<span style="color:#275a8a"><u>'+data[0].payLoad.refno+"</span></u>"+'</div></div>',
          //     icon: 'success',
          //     showCloseButton: true,
          //     showCancelButton: false,
          //     focusConfirm: false,
          //     confirmButtonText: `OK`,
          //   }).then((result) => {
          //     console.log(result)
          //     });

          // }
        })
      }
      else{
        console.log({src: '../../assets/images/NewSRactive.svg', id: "incident-new"+$(".custom-tabs li.active").find("a").attr('data-obj-id'), name:scriptpayloaddata.serviceDetails.tabname, type: 'object', entityName: 'Incident', newSr: payload, department: scriptpayloaddata.serviceDetails.caseTypeData.department.name })
        this.agentscriptservice.updateOrInsertArray(this.tab_title,'customcreatedata',{src: '../../assets/images/NewSRactive.svg', id: "incident-new"+$(".custom-tabs li.active").find("a").attr('data-obj-id'), name:scriptpayloaddata.serviceDetails.tabname, type: 'object', entityName: 'Incident', newSr: payload, department: scriptpayloaddata.serviceDetails.caseTypeData.department.name })

        this.standardservice.SavetolocalStorage('servicepayload',{src: '../../assets/images/NewSRactive.svg', id: "incident-new"+$(".custom-tabs li.active").find("a").attr('data-obj-id'), name:scriptpayloaddata.serviceDetails.tabname, type: 'object', entityName: 'Incident', newSr: payload, department: scriptpayloaddata.serviceDetails.caseTypeData.department.name })

        this.componentSelection.emit({src: '../../assets/images/NewSRactive.svg', id: "incident-new"+$(".custom-tabs li.active").find("a").attr('data-obj-id'), name:scriptpayloaddata.serviceDetails.tabname, type: 'object', entityName: 'Incident', newSr: payload, department: scriptpayloaddata.serviceDetails.caseTypeData.department.name })
      }

    }
  }


  i=1;
  togglegrid()
  {
    // alert()
    this.i++;
    if(this.i%2==1)
    this.currDiv=this.agentscriptservice.defaultview
  else
    this.currDiv=this.agentscriptservice.toggleview
  }
}
